import createTableStore from "ds/components/Table/store/useTableStore";

import { POLICIES_TABLE_COLUMNS_CONFIG, POLICIES_TABLE_STORAGE_KEY } from "./constants";

const usePoliciesTableStore = createTableStore({
  storageKey: POLICIES_TABLE_STORAGE_KEY,
  config: POLICIES_TABLE_COLUMNS_CONFIG,
});

export default usePoliciesTableStore;
